<template>
    <div class="jd-publish-form">
        <div class="jd-block__title ">选择藏品分类</div>
        <k-cell v-if="isEdit && getOrderDetail">
            <k-button type="primary" size="mini" round>{{tabName.name}}</k-button>
        </k-cell>
        <k-cell v-if="!isEdit">
            <template v-if="categoryTabs && categoryTabs.length">
                <k-button v-for="(item,index) in categoryTabs" :key="item.id" :type="info.tabid===item.id?'primary':'default'" size="mini" round @click="info.tabid=item.id">{{item.name}}</k-button>
            </template>
            <div v-else class="k-nodata">暂无分类数据！</div>
        </k-cell>

        <div class="jd-block__title ">上传图片 (正面、反面、侧面、细节图片，最大18m)</div>
        <div class="jd-publish-imgbox">
            <img-upload @success="imgSuc" :list="info.pictures" />
        </div>
        <div class="jd-block__title ">上传视频</div>
        <video-upload @success="videoSuc" :list="info.files" />
        <div class="jd-block__title ">鉴赏补充描述</div>
        <k-cell-group>
            <k-field
                v-model="info.des"
                type="textarea"
                placeholder="如：请问老师这是什么朝代的？值多少钱？"
                :maxlength="500"
                rows="3"
            />
        </k-cell-group>
        <div class="k-cell">
            <k-checkbox v-model="info.agree" name="agree" shape="square" checked-color="#CEA065" icon-size="0.3rem"><span class="fts-sm">我已阅读并同意<a href="javascript:;" @click="agreementShow=true" class="cl-blue">《玄商拍客平台鉴定规则》</a> </span></k-checkbox>
<!--            <input type="checkbox" name="agree" v-model="info.agree" /> 我已阅读并同意 <a href="" class="cl-blue">《鉴赏服务协议》</a>。-->
        </div>

        <div class="jd-fixed-btns">
            <k-row gutter="20">
                <k-col v-if="isEdit" span="24"><k-button type="primary" block @click="submit('save')" :disabled="!isNext" >重新提交</k-button></k-col>
                <k-col v-else span="24"><k-button type="primary" block @click="submit('next')" :disabled="!isNext" >下一步</k-button></k-col>
            </k-row>
        </div>
        <k-popup v-model="agreementShow">
            <div class="agreement-body">
                <iframe v-if="agreeUrl" src="" frameborder="0" :src="agreeUrl"></iframe>
            </div>
        </k-popup>
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters} from "vuex"
    import {assign} from "../../utils/xp.v1"
    import {WZ,inApp} from "../../utils/wz.v2"
    //import {CONFIG} from "../../utils/app"
    import VideoUpload from "./mod/video-upload"
    import ImgUpload from "../components/img-upload"
    import {jiandingStepCreate} from "../../api/jianding"
    export default {
        name: "pub-form",
        data(){
            return {
                agreementShow   : false,
                info : {
                    id          : +this.$route.query.id || 0,
                    des         : "",
                    tabid       : 0,
                    pictures    : null,
                    files       : null,
                    myaid       : this.$route.query.aid || 0,
                    agree       : false
                },
                imgRids         : null,
                videos          : null,
                isNext          : false

            }
        },
        computed : {
          ...mapState("jianding", ["categoryTabs"]),
          ...mapState("config", ["CONFIG"]),
          ...mapGetters("jianding", ["getOrderDetail", "getTabs"]),
          isEdit(){
              return this.$route.name === "publishEdit" ? true : false
          },
          redo(){
              return +this.$route.query.redo || 0
          },
          tabName(){
              let { getOrderDetail, getTabs } = this;
              return getTabs(getOrderDetail.tabid || 0)
          },
            agreeUrl(){
              return this.CONFIG.agreementUrl || ""
            }
        },
        components : {
            ImgUpload,
            VideoUpload
        },
        methods : {
            ...mapActions("jianding", ["loadOrderDetail"]),
            ...mapActions('account', ['loadAccount']),
            async submit(){
                let {info,imgRids, videos, redo} = this;
                let {des, tabid, myaid, id } = info;
                if(!this.ckData()) return;
                let query = {
                    des,
                    pictures: JSON.stringify(imgRids),
                    tabid
                };
                if(id && !redo){
                    query.id = id
                }
                if(videos){
                    query.files = JSON.stringify(videos)
                }

                if(myaid){
                    query.myaid = myaid
                }

                await jiandingStepCreate(query).then(R => {
                    let path = `/publish/appraisers?orderId=${R.id}&tabid=${tabid}&aid=${myaid}`;
                    if(this.isEdit && !this.redo){
                        path = '/my/order'
                    }
                    this.$router.replace({
                        path : path
                    })
                }).catch(err => {
                    this.$toast(err.message)
                })

            },
            imgSuc(data){
                console.log(JSON.stringify(data, null, 2));
                if(data.imgRids && data.imgRids.length){
                    this.imgRids = data.imgRids || ""
                } else {
                    this.imgRids = null
                }
                //this.ckData()
            },
            videoSuc(data){
                console.log(JSON.stringify(data, null, 2));
                if(data.videos) {
                    this.videos = data.videos || ""
                }
            },

            ckData(){
                let {
                    des,
                    agree,
                    tabid,
                    pictures,
                    videos
                } = this.info;
                if(!tabid){
                    this.$toast('请选择分类');
                    this.isNext = false;
                    return false
                }
                if(!this.imgRids || !this.imgRids.length ){
                    this.$toast('请上传图片');
                    this.isNext = false;
                    return false
                }
                if(!des){
                    this.$toast('请输入描述');
                    this.isNext = false;
                    return false
                }
                if(!agree){
                    this.$toast('请您勾选我已阅读并同意《鉴赏服务协议》');
                    this.isNext = false;
                    return false
                }
                this.isNext = true;
                return true
            }

        },
        async created() {
            const uinfo = await this.loadAccount();
            if(!uinfo.uid){
                WZ.go('login',{replace:true});
                return
            }
            if(this.info.id){
                this.loadOrderDetail({id:this.info.id})
            }
        },
        watch : {
            getOrderDetail(nv){
                if(nv){
                    let {des, tabid, pictures, files, myaid} = nv;
                    this.info = assign(this.info, {des, tabid, pictures, files, myaid});
                    if(pictures){
                        let arr = [];
                        pictures.forEach((item)=>{
                            arr.push(item.rid);
                        })
                        this.imgRids = arr;
                    }
                    if(files){
                        this.videos = [...files];
                    }
                }
            },
           info : {
               handler(nv){
                    //console.log(JSON.stringify(nv,null,2));
                    if(nv.tabid && nv.des && (nv.agree || this.isEdit) && this.imgRids){
                        this.isNext = true
                    } else {
                        this.isNext = false
                    }
                    this.$emit("change", {
                        info : nv,
                        isNext : this.isNext
                    })

               },
               deep : true
           }
        }
    }
</script>

<style scoped>

</style>